export const CASUS_INPUT_TYPES = { TEXT: 'text', MULTILINE: 'multiline', NUMBER: 'number', DATE_TIME: 'date-time', CURRENCY: 'currency' } as const
type CasusInputTypesType = typeof CASUS_INPUT_TYPES
export type CasusInputType = CasusInputTypesType[keyof CasusInputTypesType]
